import { render } from "./icon-exit.vue?vue&type=template&id=254d9116&scoped=true"
const script = {}

import "./icon-exit.vue?vue&type=style&index=0&id=254d9116&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254d9116"]])

export default __exports__